import { render, staticRenderFns } from "./KeysTable.vue?vue&type=template&id=ba2c9ca6&lang=pug"
import script from "./KeysTable.vue?vue&type=script&lang=js"
export * from "./KeysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports